import React from 'react';
import { Provider } from 'react-redux';
import { App as PropulsionApp } from '@ui-propulsion/react-components';
import { getStore } from './store';
import App from './components/app';
import { BrowserRouter, StaticRouter } from 'react-router-dom';

const Main = (props) => {
  const { lead } = props;
  const store = getStore(lead);
  return (
    <PropulsionApp>
      <Provider store={store}>
        <App {...props} />
      </Provider>
    </PropulsionApp>
  );
};

const ClientApp = (props) =>
  <BrowserRouter>
    <Main {...props}></Main>
  </BrowserRouter>;

const ServerApp = (props) => {
  const { location, context, ...rest } = props;
  return <StaticRouter location={location} context={context}>
    <Main {...rest}></Main>
  </StaticRouter>;
};

export default Main;

export {
  ClientApp,
  ServerApp
};

